(() => {
  const cfg = window.spConfig && window.spConfig.proof;
  const hero = document.querySelector('[data-sp-product][data-sp-pid]');
  if (!cfg || !cfg.api || !hero || window.Shopify?.designMode) return;
  const api = cfg.api.replace(/\/+$/, '') + '/api/sp';
  const pid = hero.dataset.spPid;
  let consentReady = null;
  const allowed = () => {
    if (!consentReady) {
      consentReady = new Promise((resolve) => {
        const check = () => {
          const p = window.Shopify && window.Shopify.customerPrivacy;
          resolve(!p || typeof p.analyticsProcessingAllowed !== 'function' || p.analyticsProcessingAllowed());
        };
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], check);
        } else check();
      });
    }
    return consentReady;
  };
  const send = async (type, ids) => {
    if (!(await allowed())) return;
    fetch(`${api}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: cfg.shop, type, product_ids: ids }),
      keepalive: true,
    }).catch(() => {});
  };

  send('view', [pid]);
  document.addEventListener('sp:added', (e) => send('cart', [e.detail.pid || pid]));

  const tzMin = () => {
    const m = String(window.spConfig.tz || '+03:00').trim().match(/^([+-])(\d{2}):?(\d{2})$/);
    return m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : 180;
  };
  const fill = (s, n) => s.replace(/\{\{\s*count\s*\}\}/g, n);
  const ago = (m) => (m < 60 ? fill(cfg.t.min, Math.max(1, m)) : fill(cfg.t.hours, Math.floor(m / 60)));

  function build(d) {
    const out = [];
    if (d.recent_purchases && d.recent_purchases.length) {
      const r = d.recent_purchases[0];
      out.push({ icon: 'bag', title: cfg.t.bought, sub: [r.city, ago(r.minutes_ago)].filter(Boolean).join(' · ') });
    }
    if (d.purchases_today >= 2) out.push({ icon: 'bag', html: fill(cfg.t.today, d.purchases_today) });
    if (d.carts_3h >= cfg.minCarts) out.push({ icon: 'cart', html: fill(cfg.t.carts3, d.carts_3h) });
    else if (d.carts_24h >= cfg.minCarts) out.push({ icon: 'cart', html: fill(cfg.t.carts24, d.carts_24h) });
    if (d.views_24h >= cfg.minViews) out.push({ icon: 'eye', html: fill(cfg.t.views, d.views_24h) });
    if (d.recent_purchases && d.recent_purchases[1]) {
      const r = d.recent_purchases[1];
      out.push({ icon: 'bag', title: cfg.t.bought, sub: [r.city, ago(r.minutes_ago)].filter(Boolean).join(' · ') });
    }
    return out;
  }

  const icons = {
    bag: '<path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    cart: '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12.4a1 1 0 0 0 1 .8h9.6a1 1 0 0 0 1-.8L21 7H6"/>',
    eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  };

  function show(items) {
    let shown = 0;
    try { if (sessionStorage.getItem('sp-proof-off')) return; shown = Number(sessionStorage.getItem('sp-proof-n')) || 0; } catch (_) {}
    const limit = Math.min(cfg.max, shown + items.length);
    if (!items.length || shown >= cfg.max) return;
    const card = document.createElement('div');
    card.className = 'sp-proof';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    card.dataset.testid = 'sp-proof-card';
    card.innerHTML = `<span class="sp-proof__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></svg></span><span class="sp-proof__body"></span><button type="button" class="sp-proof__close" aria-label="${cfg.t.close}" data-testid="sp-proof-close">&times;</button>`;
    document.body.appendChild(card);
    let i = 0;
    let timer;
    const next = () => {
      if (shown >= limit) return;
      const it = items[i % items.length];
      i += 1;
      shown += 1;
      try { sessionStorage.setItem('sp-proof-n', shown); } catch (_) {}
      card.querySelector('svg').innerHTML = icons[it.icon];
      const body = card.querySelector('.sp-proof__body');
      body.innerHTML = '';
      if (it.html) {
        const p = document.createElement('span');
        p.innerHTML = it.html;
        body.appendChild(p);
      } else {
        const b = document.createElement('b');
        b.textContent = it.title;
        const s = document.createElement('small');
        s.textContent = it.sub;
        body.append(b, s);
      }
      card.classList.add('is-visible');
      setTimeout(() => card.classList.remove('is-visible'), 6000);
      timer = setTimeout(next, cfg.interval * 1000);
    };
    card.querySelector('.sp-proof__close').addEventListener('click', () => {
      card.classList.remove('is-visible');
      clearTimeout(timer);
      try { sessionStorage.setItem('sp-proof-off', '1'); } catch (_) {}
    });
    timer = setTimeout(next, cfg.delay * 1000);
  }

  fetch(`${api}/proof?shop=${encodeURIComponent(cfg.shop)}&product_id=${encodeURIComponent(pid)}&tz=${tzMin()}`)
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => d && show(build(d)))
    .catch(() => {});
})();
